import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, Tabs, InputNumber, Switch } from "antd";
import { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, formatNumber, formatDate, dayjsDate, getobjkeys, formatDate2, checkp } from '../../utils/functions'
import CustModal from "../../components/ShowModal";
import ImgUploader from "../../components/ImgUploader";

function Tbsc() {
    const webPost = useWebPost();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [data1, setData1] = useState([]);
    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const pageSizeOptions = [10, 20, 50, 100, 500];

    const [form] = Form.useForm();
    const [editingRecord, setEditingRecord] = useState(null);
    const [activeKey, setActiveKey] = useState('0');
    const [config, setconfig] = useState(null);

    const loadingRef = useRef();
    useEffect(() => {
        const fetchItems = async () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            let res = [], tot = 0;
            try {
                const params = { page: currentPage, limit: pageSize, ...filters, s: activeKey };
                if (filters.singleMonth) {
                    const { startTs, endTs } = getMonthStartEnd(filters.singleMonth);
                    params.startTs = startTs;
                    params.endTs = endTs;
                }
                const response = await webPost('customerinfo_fu', params);
                if (response && response.data) {
                    if (response.total < 1) {
                        message.info('未找到匹配数据');
                    }
                    const ds1 = [];
                    const ds2 = [];
                    const ds3 = [];
                    response.data.forEach((t) => {
                        if (t.tbfiles === '' || t.tbsh3 === -1 || t.tbsh2 === -1 || t.tbsh === -1) { //需要更新标书的
                            ds1.push(t);
                            return;
                        }
                        if (t.tbsh3 === 1) { //审核完成中
                            ds3.push(t);
                            return;
                        }
                        ds2.push(t); //审核中
                    })
                    setData1(ds1);
                    setData2(ds2);
                    setData3(ds3);

                    res = response.data;
                    tot = response.total;
                }
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }

            setData(res);
            setTotal(tot);
        }
        fetchItems();
    }, [currentPage, pageSize, filters, freshData, activeKey]);

    const columns = [
        {
            title: '序号', dataIndex: 'xd', width: 80, fixed: 'left',
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        { title: '年份', dataIndex: 'co_date', width: 120 },
        { title: '项目编号', dataIndex: 'sn', width: 120 },
        { title: '项目名称', dataIndex: 'xmmc', width: 120, ellipsis: { showTitle: true, } },
        { title: '招标单位/招标代理机构', dataIndex: 'xmdjxx1', width: 160, ellipsis: { showTitle: true, } },
        { title: '投标保证金', dataIndex: 'tbbzj', width: 120 },
        {
            title: '参与/中标/自营', dataIndex: 'type', width: 120, ellipsis: { showTitle: true, }, render: (v) =>
                <div
                    style={{
                        width: '100%',
                        whiteSpace: 'pre-wrap', // 解析换行符（\n）
                        wordBreak: 'break-all', // 超长字符换行
                        lineHeight: '1.4', // 行高适配
                        padding: '2px 0', // 内边距优化
                        overflow: 'hidden' // 配合ellipsis，超出宽度隐藏
                    }}
                >
                    {v || '-'} {/* 空值显示占位符 */}
                </div>
        },
        { title: '授权委托人', dataIndex: 'wtname', width: 120, },
        { title: '项目经理', dataIndex: 'xmjl', width: 120, },
        { title: '填报企业', dataIndex: 'com_tianbao', width: 120, },
        { title: '标书编制人', dataIndex: 'bsbzr', width: 120 },
        { title: '标书上传时间', dataIndex: 'updtm', width: 120 },
        { title: '投标截止时间', dataIndex: 'enddtm', width: 120 },

        // { title: '合同类型', dataIndex: 'co_type', width: 120, },
        // { title: '业主名称', dataIndex: 'customer_name', width: 120, ellipsis: { showTitle: true, }, },
        // { title: '实际合同额(万元)', dataIndex: 'sjamount', width: 120, render: (v) => formatNumber(v / 10000) },
        // { title: '税率（%）', dataIndex: 'zylx', width: 120, },
        // { title: '项目地点', dataIndex: 'location', width: 100, ellipsis: { showTitle: true, } },
        // { title: '项目规模', dataIndex: 'xmgm', width: 100, ellipsis: { showTitle: true, } },
        // { title: '合同范围', dataIndex: 'htfw', width: 100, ellipsis: { showTitle: true, } },
        // { title: '招标范围', dataIndex: 'zbfw', width: 100, ellipsis: { showTitle: true, } },
        // { title: '预付款', dataIndex: 'amount', width: 100, ellipsis: { showTitle: true, }, render: () => '这个放哪里填写' },
        // { title: '进度款支付比例', dataIndex: 'amount', width: 100, ellipsis: { showTitle: true, }, render: () => '这个放哪里填写' },
        // { title: '履约保证金形式', dataIndex: 'sdf', width: 100, render: () => '这个放哪里填写' },
        // { title: '履约保证金', dataIndex: 'lybzj', width: 100, },
        // { title: '质保金比例', dataIndex: 'zbbzj_paytype', width: 100, },
        { title: '备注', dataIndex: 'ps', width: 100, ellipsis: { showTitle: true, } },
        activeKey === '-1' && {
            title: '申请被拒原因', key: 'bps', width: 100, render: (t, rs) => {
                const res = [];
                if (rs.tbshps) res.push(<div style={{ color: 'red' }} key='ra1'>{rs.tbshps}</div>)
                if (rs.tbsh1ps) res.push(<div style={{ color: 'red' }} key='ra2'>{rs.tbsh1ps}</div>)
                if (rs.tbsh2ps) res.push(<div style={{ color: 'red' }} key='ra3'>{rs.tbsh2ps}</div>)
                return res;
            }
        },
        checkp(['tbsc']) && {
            title: '操作',
            key: 'action',
            width: 160,
            fixed: 'right',
            render: (_, record) => <Button type="link" onClick={() => showModal(record, "scbs")} >上传标书</Button>,
        },
    ].filter(Boolean);

    const showModal = async (record = null, action) => {
        if (!record) {
            message.error("错误的参数");
            return;
        }
        setEditingRecord(record);
        setModalVisible(action);
        form.setFieldsValue(record);
    };
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const payload = editingRecord
                ? {
                    ...values, sn: editingRecord.sn,
                }
                : values;

            const res = await webPost('customerinfo_fus', payload);
            if (res) {
                message.success(editingRecord ? '更新成功' : '新增成功');
                saveSuccess();
            }
        } catch (err) {
            console.error('表单验证或提交错误:', err);
        }
    };

    const handleModalClose = () => {
        setModalVisible('');
        setEditingRecord(null);
    }
    const saveSuccess = () => {
        setfreshData(Math.random()); //强制刷新数据
        handleModalClose();
    };
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    return (
        <FullHeightLayout
            headerContent={null}
            bodyContent={
                <>

                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="id"
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 1800,
                            y: 'calc(100vh - 300px)',
                        }}
                        tableLayout="fixed"
                    />
                    <CustModal
                        title={editingRecord ? '上传标书' : '更新标书'}
                        open={modalVisible === 'scbs'}
                        onOk={handleOk}
                        onCancel={handleModalClose}
                        okText="保存"
                        cancelText="取消"
                    >
                        <Form form={form} layout="vertical">
                            <Form.Item
                                name="tbfiles"
                                label="商务标书"
                            >
                                <ImgUploader />
                            </Form.Item>
                            <Form.Item
                                name="tbfiles1"
                                label="技术标书"
                            >
                                <ImgUploader />
                            </Form.Item>
                            <Form.Item
                                name="tbfiles2"
                                label="其它标书"
                            >
                                <ImgUploader />
                            </Form.Item>

                        </Form>
                    </CustModal>
                </>
            }
            footerContent={<div style={{
                display: 'flex', justifyContent: 'flex-end',
                alignItems: 'center',
            }}>
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={total}
                    showSizeChanger
                    showQuickJumper
                    showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                    onChange={onPageChange}
                    pageSizeOptions={pageSizeOptions}
                />
            </div>}
        />
    )
}


export default Tbsc;
